// src\themes\lino\components\ImageWidget.tsx
'use client';

import Image from "next/image";
import Link from "next/link";
import { motion } from "motion/react";
import { textGroupVariants, textItemVariants } from "./animations/textReveal";

const isVideoUrl = (url?: string) => {
    if (!url) return false;
    return /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(url);
};

export default function ImageWidget({ data }: { data: any }) {
    const image = data?.image || data.thumbnail

    const textAlign = data.direction === 'center' ? 'text-center' : data.direction === 'right' ? 'text-start' : 'text-start';
    const widthMap: Record<string, string> = {
        '1/1': 'col-span-12',
        '1/2': 'col-span-12 md:col-span-6',
        '1/3': 'col-span-12 md:col-span-4',
        '1/4': 'col-span-12 md:col-span-3',
        '2/3': 'col-span-12 md:col-span-8',
        '3/4': 'col-span-12 md:col-span-9',
    };
    const width = widthMap[data.width || '1/1'];

    const aspect = data.orientation === undefined ? "aspect-[16/9]" : data.orientation === "horizontal" ? "aspect-[16/9]" : "aspect-[3/4]"

    const imageBox = (
        <div className={`relative w-full overflow-hidden rounded-2xl ${!data.title && !data.description ? "flex-1 h-full" : ""} ${aspect}`}>
            {image?.url && (
                isVideoUrl(image.url) ? (
                    <video
                        src={image.url}
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="w-full h-full object-cover absolute"
                    />
                ) : (
                    <Image
                        src={image.url}
                        alt={image?.name || image?.description || data.title || data.description || 'تصویر'}
                        fill
                        className="object-cover absolute"
                    />
                )
            )}
        </div>
    );

    return (
        <div className={`space-y-4 flex flex-col h-full ${width} ${textAlign}`}>
            {data.link ? (
                <Link href={data.link} className="block">
                    {imageBox}
                </Link>
            ) : (
                imageBox
            )}
            {(data.title || data.description) && (
                <motion.div
                    className="space-y-4"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.4 }}
                    variants={textGroupVariants}
                >
                    {data.title && (
                        <motion.h2 variants={textItemVariants} className="text-lg lg:text-xl font-light text-primary-900 tracking-tight">
                            {data.title}
                        </motion.h2>
                    )}
                    {data.description && (
                        <motion.p variants={textItemVariants} className="text-primary-600 text-[13px] whitespace-pre-line leading-6">
                            {data.description}
                        </motion.p>
                    )}
                </motion.div>
            )}
        </div>
    );
}